/**
 * @typedef {import('../types/FileSizeObject').default} FileSize
 */
const {
	gigabyteInBytes,
	kilobyteInBytes,
	megabyteInBytes,
} = require('../constants/filesize');

/**
 * @param {string} string
 * @returns {FileSize}
 */
function parseString(string) {
	const number = parseInt(string, 10);
	const sizeIn = string.replace(/[^a-zA-Z]*/, '').toUpperCase();
	const format = ['B', 'GB', 'KB', 'MB'].includes(sizeIn) ? sizeIn : 'B';

	// @ts-ignore: `format` is set to valid `FileSizeFormat` by the logic above
	return { format, size: number };
}

/**
 * @param {string} string
 * @returns {number}
 */
function convertStringToBytes(string) {
	return convertToBytes(parseString(string));
}

/**
 * @param {FileSize} filesize
 * @returns {number}
 */
function convertToBytes(filesize) {
	const format = filesize.format.toUpperCase();
	let multiplier = 1;

	/* eslint-disable default-case */
	switch (format) {
		case 'GB':
			multiplier = gigabyteInBytes;
			break;

		case 'KB':
			multiplier = kilobyteInBytes;
			break;

		case 'MB':
			multiplier = megabyteInBytes;
			break;
	}
	/* eslint-enable default-case */

	return filesize.size * multiplier;
}

module.exports = {
	convertStringToBytes,
	convertToBytes,
};
